
import { Component, Prop, Vue } from 'vue-property-decorator'
import { useCultureSubsidyStore } from '@/stores/cultureSubsidy'
import { EnrichedProduct, RuleSource } from '../types'

@Component({ name: 'ProductsPanel' })
export default class extends Vue {
  @Prop({ default: false }) editable!: boolean

  store = useCultureSubsidyStore()
  search = ''
  brand = ''
  eligibility = 'all'

  get brands(): string[] {
    return Array.from(new Set(this.store.products.map(product => product.brand)))
  }

  get showValues(): boolean {
    return !!this.store.settings?.perProductValueMode
  }

  get filtered(): EnrichedProduct[] {
    return this.store.enrichedProducts.filter(product => {
      if (this.brand && product.brand !== this.brand) return false
      if (this.eligibility === 'yes' && !product.eligible) return false
      if (this.eligibility === 'no' && product.eligible) return false
      if (this.search) {
        const q = this.search.toLowerCase()
        if (!`${product.name} ${product.brand}`.toLowerCase().includes(q)) return false
      }
      return true
    })
  }

  tagType(source: RuleSource): string {
    if (source === 'special_product' || source === 'special_global') return 'warning'
    if (source === 'product_value') return ''
    return 'info'
  }

  async toggleEligible(id: string, eligible: boolean | string | number): Promise<void> {
    try {
      await this.store.updateProduct(id, { eligible: Boolean(eligible) })
    } catch (error) {
      this.$message.error((error as Error).message)
    }
  }

  async setValue(id: string, value: number): Promise<void> {
    try {
      await this.store.updateProduct(id, { valuePerProduct: value })
    } catch (error) {
      this.$message.error((error as Error).message)
    }
  }
}
